type MenuItem = {
  title?: string
  shouldShow?: boolean
  cards?: MenuItem[]
  [key: string]: any
}

export const cloneVisibleMenuItem = (item: MenuItem): MenuItem => ({
  ...item,
  cards: item.cards?.filter((child) => child.shouldShow)?.map((child) => cloneVisibleMenuItem(child)),
})

export const itemTitleMatchesSearch = (
  title: string | undefined,
  searchTerm: string,
  translate: (key: string) => unknown
): boolean => {
  if (!title || !searchTerm) return false
  if (title.toLowerCase().includes(searchTerm)) return true
  const translated = translate(title)
  return typeof translated === 'string' && translated.toLowerCase().includes(searchTerm)
}

export const filterVisibleMenuItem = (
  item: MenuItem,
  searchTerm: string,
  translate: (key: string) => unknown
): MenuItem | null => {
  if (!item.shouldShow) return null

  if (itemTitleMatchesSearch(item.title, searchTerm, translate)) return cloneVisibleMenuItem(item)

  const filteredCards = item.cards
    ?.map((child) => filterVisibleMenuItem(child, searchTerm, translate))
    .filter(Boolean) as MenuItem[] | undefined

  if (filteredCards?.length) {
    return { ...item, cards: filteredCards, shouldShow: true }
  }

  return null
}

export const filterVisibleMenuData = (
  menuData: MenuItem[],
  searchTerm: string,
  translate: (key: string) => unknown
): MenuItem[] =>
  menuData.map((category) => filterVisibleMenuItem(category, searchTerm, translate)).filter(Boolean) as MenuItem[]
